import {
  V1AdminsApi,
  V1AdminsAppMediaApi,
  V1AdminsAppMediaStorageApi,
  V1AdminsDisputesApi,
  V1AdminsPromotionNotificationsApi,
  V1AdminsUsersApi,
} from './generated';

import { AppConfig } from 'config';
import { http } from '../services';

export const api = {
  V1AdminsApi: new V1AdminsApi(undefined, AppConfig.BASE_API_URL, http),
  V1AdminsUsersApi: new V1AdminsUsersApi(undefined, AppConfig.BASE_API_URL, http),
  V1AdminsAppMediaStorageApi: new V1AdminsAppMediaStorageApi(undefined, AppConfig.BASE_API_URL, http),
  V1AdminsAppMediaApi: new V1AdminsAppMediaApi(undefined, AppConfig.BASE_API_URL, http),
  V1AdminsPromotionNotificationsApi: new V1AdminsPromotionNotificationsApi(undefined, AppConfig.BASE_API_URL, http),
  V1AdminsDisputesApi: new V1AdminsDisputesApi(undefined, AppConfig.BASE_API_URL, http),
};
